/** 明細テーブル f 列 ID（f1〜f74） */
export const MEISAI_F_COLUMN_IDS = Array.from({ length: 74 }, (_, i) => `f${i + 1}`) as readonly string[]

/** 列表示で常に表示する f 列（凍結列） */
export const MEISAI_ALWAYS_VISIBLE_F_KEYS = ['f1', 'f2', 'f3', 'f4'] as const

/** 日付複合ソートグループ */
export const MEISAI_DATE_SORT_GROUPS: Record<string, readonly string[]> = {
  f2: ['f2', 'f3', 'f4'],
  f3: ['f2', 'f3', 'f4'],
  f4: ['f2', 'f3', 'f4'],
  f6: ['f6', 'f7', 'f8'],
  f7: ['f6', 'f7', 'f8'],
  f8: ['f6', 'f7', 'f8'],
}

/** 確認・メモ列のソートキー */
export const MEISAI_REVIEW_SORT_KEYS = ['reviewed', 'reviewMemo'] as const

/** No. 列（絶対行号）の絞込キー */
export const LINE_NO_FILTER_KEY = 'lineNo' as const

/** 確認・メモ列の絞込キー */
export const REVIEW_FILTER_KEY = 'reviewed' as const
export const REVIEW_MEMO_FILTER_KEY = 'reviewMemo' as const

/** 確認列絞込ドロップダウン選択肢 */
export const REVIEW_STATUS_FILTER_OPTIONS = [
  { value: '', label: 'すべて' },
  { value: 'true', label: '確認済' },
  { value: 'false', label: '未確認' },
] as const

/** 並び替え中に列を非表示にしようとしたときのメッセージ */
export const MEISAI_SORT_HIDE_BLOCKED_MSG = '並び替え中の項目は非表示にできません。'
